(function () {
  /* ── Native share buttons ── */
  document.querySelectorAll('.lhfp-share__btn--native').forEach(function (btn) {
    if (navigator.share) {
      btn.addEventListener('click', function () {
        navigator.share({
          title: btn.dataset.title || document.title,
          url: btn.dataset.url || window.location.href
        }).catch(function () {});
      });
    } else {
      btn.style.display = 'none';
    }
  });

  /* ── Copy-link buttons ── */
  document.querySelectorAll('.lhfp-share__btn--copy').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var url = btn.dataset.url || window.location.href;
      var txt = btn.querySelector('.lhfp-share__copy-txt');
      navigator.clipboard.writeText(url).then(function () {
        btn.classList.add('lhfp-share__btn--copied');
        if (txt) txt.textContent = 'Copied!';
        setTimeout(function () {
          btn.classList.remove('lhfp-share__btn--copied');
          if (txt) txt.textContent = 'Copy link';
        }, 1500);
      });
    });
  });
})();
